"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.AspectsPatterns = void 0;
var defs_1 = require("./defs");
var AspectsPatterns = (function () {
    function AspectsPatterns(aspects) {
        var _this = this;
        this.getComparable = function (points) { return JSON.stringify(points.sort(function (a, b) { return a - b; })); };
        this.getAspectById = function (aspects, id) { return aspects.find(function (a) { return a.id === id; }); };
        this.isApectInPattern = function (aspect, patterns, patternName) { return patterns.find(function (pattern) { return _this.getAspectById(pattern.aspects, aspect.id); }); };
        this.isPointInPattern = function (point, pattern) { return pattern.points.includes(point); };
        this.isPointInAspect = function (aspect, point) { return point === aspect.obj1 || point === aspect.obj2; };
        this.mergePatterns = function (patterns, aspectMap) {
            var _a, _b, _c;
            if (aspectMap === void 0) { aspectMap = []; }
            var patternsToProcess = _this.mergeConjunctionObjectsToPatterns(JSON.parse(JSON.stringify(patterns)), aspectMap, { skipNonConfigurationObjects: true });
            var isPatternsEqual = function (pattern1, pattern2) {
                if (patternsToProcess.indexOf(pattern1) === patternsToProcess.indexOf(pattern2))
                    return false;
                if (_this.getComparable(pattern1.points) === _this.getComparable(pattern2.points))
                    return true;
                return false;
            };
            var _loop_1 = function (pattern) {
                var equalPatterns = patternsToProcess.filter(function (equalPattern) { return isPatternsEqual(equalPattern, pattern); });
                if (equalPatterns.length === 0) {
                    pattern.mergedObjects = [];
                    var oldPattern = patterns.find(function (oldPattern) { return oldPattern.id === pattern.id; });
                    pattern.points = (_a = oldPattern === null || oldPattern === void 0 ? void 0 : oldPattern.points) !== null && _a !== void 0 ? _a : pattern.points;
                    pattern.aspects = (_b = oldPattern === null || oldPattern === void 0 ? void 0 : oldPattern.aspects) !== null && _b !== void 0 ? _b : pattern.aspects;
                }
                ;
                var _loop_2 = function (equalPattern) {
                    pattern.aspects = pattern.aspects.concat(equalPattern.aspects);
                    var possiblePatternIds = __spreadArray([pattern.id], equalPatterns.map(function (id) { return id.id; }), true);
                    pattern.points = pattern.points.filter(function (point) { return patterns.filter(function (pat) { return pat.name === pattern.name; }).find(function (pat) { return _this.isPointInPattern(point, pat) && possiblePatternIds.includes(pat.id); }); });
                    pattern.aspects = pattern.aspects.filter(function (asp) { return pattern.points.includes(asp.obj1) && pattern.points.includes(asp.obj2); });
                    pattern.mergedObjects = (_c = pattern.mergedObjects) === null || _c === void 0 ? void 0 : _c.map(function (mergedObjects) { return mergedObjects.filter(function (mergedPoint) { return pattern.points.includes(mergedPoint); }); }).filter(function (mergedObjects) { return mergedObjects.length > 1; });
                    var index = patternsToProcess.indexOf(equalPattern);
                    patternsToProcess.splice(index, 1);
                };
                for (var _d = 0, equalPatterns_1 = equalPatterns; _d < equalPatterns_1.length; _d++) {
                    var equalPattern = equalPatterns_1[_d];
                    _loop_2(equalPattern);
                }
            };
            for (var _i = 0, patternsToProcess_1 = patternsToProcess; _i < patternsToProcess_1.length; _i++) {
                var pattern = patternsToProcess_1[_i];
                _loop_1(pattern);
            }
            return patternsToProcess;
        };
        this.includesAll = function (arr, values) { return values.every(function (v) { return arr.includes(v); }); };
        this.mergePatternsPoints = function (pattern1, pattern2) {
            pattern1.points = Array.from(new Set(__spreadArray(__spreadArray([], pattern1.points, true), pattern2.points, true)));
            pattern1.aspects = Array.from(new Set(__spreadArray(__spreadArray([], pattern1.aspects, true), pattern2.aspects, true)));
        };
        this.mergeConjunctionObjectsToPatterns = function (patterns, aspectMap, options) {
            var conjunctions = aspectMap.filter(function (asp) { return asp.type === defs_1.AspectType.Conjunction; });
            var _loop_3 = function (pattern) {
                if (pattern.name === defs_1.EPatternName.stellium)
                    return "continue";
                pattern.points.map(function (point) {
                    var aspectsWithConjunction = conjunctions.filter(function (conjunction) { return _this.isPointInAspect(conjunction, point); });
                    aspectsWithConjunction.forEach(function (conjunction) {
                        var _a, _b;
                        var conjunctionPoint = conjunction.obj1 === point ? conjunction.obj2 : conjunction.obj1;
                        var aspectMergedObjects = [conjunction.obj1, conjunction.obj2];
                        if ((_a = pattern.mergedObjects) === null || _a === void 0 ? void 0 : _a.find(function (mergedObjects) { return _this.getComparable(mergedObjects) === _this.getComparable(aspectMergedObjects); }))
                            return;
                        var configurations = patterns.filter(function (seachingPattern) {
                            return pattern.id !== seachingPattern.id
                                && seachingPattern.points.includes(conjunctionPoint)
                                && (pattern.name === seachingPattern.name);
                        });
                        if ((options === null || options === void 0 ? void 0 : options.skipNonConfigurationObjects) && !configurations.filter(function (seachingPattern) { return pattern.name === seachingPattern.name; }).length)
                            return;
                        var aspect = aspectMap.find(function (asp) { return asp.obj1 === conjunction.obj1 && asp.obj2 === conjunction.obj2; });
                        if (aspect)
                            pattern.aspects.push(aspect);
                        var stellumConfiguration = patterns.find(function (conjunction) { return conjunction.name === defs_1.EPatternName.stellium && conjunction.points.includes(conjunctionPoint); });
                        if (stellumConfiguration) {
                            aspectMergedObjects.push.apply(aspectMergedObjects, stellumConfiguration.points);
                            _this.mergePatternsPoints(pattern, stellumConfiguration);
                        }
                        else {
                            pattern.points.push(conjunctionPoint);
                        }
                        pattern.mergedObjects = (pattern === null || pattern === void 0 ? void 0 : pattern.mergedObjects) ? pattern.mergedObjects.concat([aspectMergedObjects]) : [aspectMergedObjects];
                        var _loop_4 = function (points) {
                            if (points.includes(point) && !points.includes(conjunctionPoint)) {
                                points.push(conjunctionPoint);
                            }
                            var relative = pattern.mergedObjects.find(function (mergedObjects) {
                                var _a, _b;
                                return _this.includesAll(points, mergedObjects) && ((_a = pattern.mergedObjects) === null || _a === void 0 ? void 0 : _a.indexOf(points)) !== ((_b = pattern.mergedObjects) === null || _b === void 0 ? void 0 : _b.indexOf(mergedObjects));
                            });
                            if (relative)
                                pattern.mergedObjects.splice(pattern.mergedObjects.indexOf(relative), 1);
                        };
                        for (var _i = 0, _c = pattern.mergedObjects; _i < _c.length; _i++) {
                            var points = _c[_i];
                            _loop_4(points);
                        }
                        pattern.mergedObjects = (_b = pattern.mergedObjects) === null || _b === void 0 ? void 0 : _b.map(function (mergedObjects) { return Array.from(new Set(mergedObjects)); });
                    });
                });
                var isPatternsEqual = function (pattern1, pattern2) {
                    if (patterns.indexOf(pattern1) === patterns.indexOf(pattern2))
                        return false;
                    if (_this.getComparable(pattern1.points) === _this.getComparable(pattern2.points))
                        return true;
                    return false;
                };
            };
            for (var _i = 0, patterns_1 = patterns; _i < patterns_1.length; _i++) {
                var pattern = patterns_1[_i];
                _loop_3(pattern);
            }
            return patterns;
        };
        this.aspects = aspects
            .sort(function (a, b) { return a.type >= b.type ? 1 : -1; });
    }
    AspectsPatterns.prototype.findPatterns = function () {
        var figures = {};
        figures.trigon = this.findTriangles(120, 120, 120, defs_1.EPatternName.trigon);
        figures.bisextil = this.findTriangles(120, 60, 60, defs_1.EPatternName.bisextil);
        figures.roof = this.findTriangles(60, 30, 30, defs_1.EPatternName.roof);
        figures.perst = this.findTriangles(60, 150, 150, defs_1.EPatternName.perst);
        figures.cross = this.findRect(90, 90, 90, 90, 180, 180, defs_1.EPatternName.cross);
        figures.tau = this.findTriangles(180, 90, 90, defs_1.EPatternName.tau);
        figures.dart = this.findTriangles(90, 45, 45, defs_1.EPatternName.dart);
        figures.axe = this.findTriangles(90, 135, 135, defs_1.EPatternName.axe);
        figures.dagger = this.findRect(135, 45, 45, 135, 180, 90, defs_1.EPatternName.dagger);
        figures.wagon = this.findRect(120, 60, 120, 60, 180, 180, defs_1.EPatternName.wagon);
        figures.semiWagon = this.findTriangles(180, 60, 120, defs_1.EPatternName.semiWagon);
        figures.trapeze = this.findRect(180, 60, 60, 60, 120, 120, defs_1.EPatternName.trapeze);
        figures.sail = this.findRect(120, 120, 60, 60, 120, 180, defs_1.EPatternName.sail);
        figures.fence = this.findRect(150, 30, 150, 30, 180, 180, defs_1.EPatternName.fence);
        figures.ship = this.findTriangles(144, 72, 72, defs_1.EPatternName.ship);
        figures.palm = this.findTriangles(72, 144, 144, defs_1.EPatternName.palm);
        figures.boat = this.findTriangles(72, 36, 36, defs_1.EPatternName.boat);
        figures.compass = this.findTriangles(180, 108, 72, defs_1.EPatternName.compass);
        figures.lock = this.findTriangles(40, 20, 20, defs_1.EPatternName.lock);
        figures.lasso = this.findTriangles(80, 40, 40, defs_1.EPatternName.lasso);
        figures.cell = this.findCell(9, 40, defs_1.EPatternName.cell);
        figures.box = this.findRect(100, 40, 20, 40, 60, 60, defs_1.EPatternName.box);
        figures.petrov = this.findRect(80, 100, 80, 100, 180, 180, defs_1.EPatternName.petrov);
        figures.stellium = this.findStelliums(defs_1.EPatternName.stellium);
        var array = [];
        for (var key in figures) {
            if (figures[key]) {
                array.push.apply(array, figures[key]);
            }
        }
        function compare(a1, a2) {
            return a1.length == a2.length && a1.every(function (v, i) { return v === a2[i]; });
        }
        function compareNumbers(a, b) {
            return a - b;
        }
        var uniqueArray = [];
        array.forEach(function (item) {
            var found = false;
            for (var i = 0; i < uniqueArray.length; i++) {
                if (compare(uniqueArray[i].points.sort(compareNumbers), item.points.sort(compareNumbers))) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                uniqueArray.push(item);
            }
        });
        return uniqueArray;
    };
    AspectsPatterns.prototype.findStelliums = function (name) {
        var result = [];
        var bases = this.aspects.filter(function (aspect) { return aspect.type === 0; });
        function fn(base, items) {
            var result = [base];
            var found = true;
            while (found) {
                found = false;
                result.forEach(function (a) {
                    items.forEach(function (b, i) {
                        if (a.obj1 === b.obj1 || a.obj1 === b.obj2 ||
                            a.obj2 === b.obj1 || a.obj2 === b.obj2) {
                            result.push.apply(result, items.splice(i, 1));
                            found = true;
                        }
                    });
                });
            }
            return result;
        }
        bases.forEach(function (item) {
            var others = bases.filter(function (item2) { return item2 !== item; });
            var figure = fn(item, others);
            if (figure.length >= 2) {
                var allObjects = figure.reduce(function (a, b) { return __spreadArray(__spreadArray([], a, true), [b.obj1, b.obj2], false); }, []);
                var withoutRepeat = allObjects.filter(function (item, index, array) {
                    return array.indexOf(item) === index;
                });
                result.push(new AspectsPattern("chronos.app.instruments.widgets.analyze.stellium", __spreadArray([], withoutRepeat, true), __spreadArray([], figure, true)));
            }
        });
        return result;
    };
    AspectsPatterns.prototype.findTriangles = function (base, side1, side2, name) {
        var result = [];
        var bases = this.aspects.filter(function (aspect) { return aspect.type === base; });
        var sides1 = this.aspects.filter(function (aspect) { return aspect.type === side1; });
        var sides2 = this.aspects.filter(function (aspect) { return aspect.type === side2; });
        if (bases.length === 0 || sides1.length === 0 || sides2.length === 0) {
            return;
        }
        for (var b = 0; b < bases.length; b++) {
            var base_1 = bases[b];
            for (var s1 = 0; s1 < sides1.length; s1++) {
                var side1_1 = sides1[s1];
                if (base_1.id === side1_1.id) {
                    continue;
                }
                var side1Founded = false;
                var side2Points = [];
                if (base_1.obj1 === side1_1.obj1) {
                    side1Founded = true;
                    side2Points = [base_1.obj2, side1_1.obj2];
                }
                else if (base_1.obj1 === side1_1.obj2) {
                    side1Founded = true;
                    side2Points = [base_1.obj2, side1_1.obj1];
                }
                else if (base_1.obj2 === side1_1.obj1) {
                    side1Founded = true;
                    side2Points = [base_1.obj1, side1_1.obj2];
                }
                else if (base_1.obj2 === side1_1.obj2) {
                    side1Founded = true;
                    side2Points = [base_1.obj1, side1_1.obj1];
                }
                if (!side1Founded) {
                    continue;
                }
                for (var s2 = 0; s2 < sides2.length; s2++) {
                    var side2_1 = sides2[s2];
                    if (base_1.id === side2_1.id || side1_1.id === side2_1.id) {
                        continue;
                    }
                    if (side2_1.obj1 === side2Points[0] && side2_1.obj2 === side2Points[1]
                        || side2_1.obj1 === side2Points[1] && side2_1.obj2 === side2Points[0]) {
                        result.push(new AspectsPattern(name, [side1_1.obj1, side1_1.obj2, side2_1.obj1, side2_1.obj2].filter(function (item, index, array) {
                            return array.indexOf(item) === index;
                        }), [base_1, side1_1, side2_1]));
                    }
                }
            }
        }
        return result;
    };
    AspectsPatterns.prototype.findRect = function (side1, side2, side3, side4, opposite1, opposite2, name) {
        var result = [];
        var sides1 = this.aspects.filter(function (aspect) { return aspect.type === side1; });
        var sides2 = this.aspects.filter(function (aspect) { return aspect.type === side2; });
        var sides3 = this.aspects.filter(function (aspect) { return aspect.type === side3; });
        var sides4 = this.aspects.filter(function (aspect) { return aspect.type === side4; });
        var opposites1 = this.aspects.filter(function (aspect) { return aspect.type === opposite1; });
        var opposites2 = this.aspects.filter(function (aspect) { return aspect.type === opposite2; });
        if (sides1.length === 0 || sides2.length === 0 || sides3.length === 0 || sides4.length === 0) {
            return;
        }
        if (opposites1.length === 0 || opposites2.length === 0) {
            return;
        }
        for (var s1 = 0; s1 < sides1.length; s1++) {
            var side1_2 = sides1[s1];
            for (var s2 = 0; s2 < sides2.length; s2++) {
                var side2_2 = sides2[s2];
                if (side1_2.id === side2_2.id) {
                    continue;
                }
                var side2To3 = null;
                var side1To4 = null;
                var side1To2 = null;
                if (side1_2.obj1 === side2_2.obj1) {
                    side1To2 = side1_2.obj1;
                    side1To4 = side1_2.obj2;
                    side2To3 = side2_2.obj2;
                }
                else if (side1_2.obj1 === side2_2.obj2) {
                    side1To2 = side1_2.obj1;
                    side1To4 = side1_2.obj2;
                    side2To3 = side2_2.obj1;
                }
                else if (side1_2.obj2 === side2_2.obj1) {
                    side1To2 = side1_2.obj2;
                    side1To4 = side1_2.obj1;
                    side2To3 = side2_2.obj2;
                }
                else if (side1_2.obj2 === side2_2.obj2) {
                    side1To2 = side1_2.obj2;
                    side1To4 = side1_2.obj1;
                    side2To3 = side2_2.obj1;
                }
                if (!side2To3) {
                    continue;
                }
                for (var s3 = 0; s3 < sides3.length; s3++) {
                    var side3_1 = sides3[s3];
                    if (side1_2.id === side3_1.id || side2_2.id === side3_1.id) {
                        continue;
                    }
                    var side3To4 = null;
                    if (side2_2.obj1 === side3_1.obj1) {
                        side3To4 = side3_1.obj2;
                    }
                    else if (side2_2.obj1 === side3_1.obj2) {
                        side3To4 = side3_1.obj1;
                    }
                    else if (side2_2.obj2 === side3_1.obj1) {
                        side3To4 = side3_1.obj2;
                    }
                    else if (side2_2.obj2 === side3_1.obj2) {
                        side3To4 = side3_1.obj1;
                    }
                    if (!side3To4) {
                        continue;
                    }
                    for (var s4 = 0; s4 < sides4.length; s4++) {
                        var side4_1 = sides4[s4];
                        if (side1_2.id === side4_1.id || side2_2.id === side4_1.id || side3_1.id === side4_1.id) {
                            continue;
                        }
                        if (side4_1.obj1 === side1To4 && side4_1.obj2 === side3To4 ||
                            side4_1.obj1 === side3To4 && side4_1.obj2 === side1To4) {
                            for (var o1 = 0; o1 < opposites1.length; o1++) {
                                var opposite1_1 = opposites1[o1];
                                if (opposite1_1.id === side1_2.id || opposite1_1.id === side2_2.id) {
                                    continue;
                                }
                                if (opposite1_1.id === side3_1.id || opposite1_1.id === side4_1.id) {
                                    continue;
                                }
                                if (opposite1_1.obj1 === side2To3 && opposite1_1.obj2 === side1To4 ||
                                    opposite1_1.obj1 === side1To4 && opposite1_1.obj2 === side2To3) {
                                    for (var o2 = 0; o2 < opposites2.length; o2++) {
                                        var opposite2_1 = opposites2[o2];
                                        if (opposite2_1.id === side1_2.id || opposite2_1.id === side2_2.id) {
                                            continue;
                                        }
                                        if (opposite2_1.id === side3_1.id || opposite2_1.id === side4_1.id) {
                                            continue;
                                        }
                                        if (opposite2_1.id === opposite1_1.id) {
                                            continue;
                                        }
                                        if (opposite2_1.obj1 === side3To4 && opposite2_1.obj2 === side1To2
                                            || opposite2_1.obj1 === side1To2 && opposite2_1.obj2 === side3To4) {
                                            result.push(new AspectsPattern(name, [side1_2.obj1, side1_2.obj2, side3_1.obj1, side3_1.obj2].filter(function (item, index, array) {
                                                return array.indexOf(item) === index;
                                            }), [side1_2, side2_2, side3_1, side4_1, opposite1_1, opposite2_1]));
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return result;
    };
    AspectsPatterns.prototype.findCell = function (count, type, name) {
        if (count === void 0) { count = 9; }
        if (type === void 0) { type = 40; }
        var result = [];
        var sides = this.aspects.filter(function (aspect) { return aspect.type === type; });
        if (sides.length < count) {
            return;
        }
        var side = sides[0];
        var foundSides = [side];
        var foundAspects = this.findCellRec(side.obj2, sides, foundSides, side.obj1, count);
        if (foundAspects) {
            var foundPoints = foundAspects
                .reduce(function (a, b) { return __spreadArray(__spreadArray([], a, true), [b.obj1, b.obj2], false); }, [])
                .filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
            result.push(new AspectsPattern(name, foundPoints, []));
        }
        return result;
    };
    AspectsPatterns.prototype.findCellRec = function (point, sides, foundSides, firstPoint, sidesCount) {
        var leftSides = sides.filter(function (item) { return foundSides.indexOf(item) === -1; });
        for (var i = 0; i < leftSides.length; i++) {
            var side = leftSides[i];
            var nextPoint = null;
            if (foundSides.length === sidesCount - 1) {
                if (side.obj1 === point && side.obj2 === firstPoint || side.obj2 === point && side.obj1 === firstPoint) {
                    return __spreadArray(__spreadArray([], foundSides, true), [side], false);
                }
            }
            else {
                if (side.obj1 === point) {
                    nextPoint = side.obj2;
                }
                else if (side.obj2 === point) {
                    nextPoint = side.obj1;
                }
                if (nextPoint) {
                    return this.findCellRec(nextPoint, sides, __spreadArray(__spreadArray([], foundSides, true), [side], false), firstPoint, sidesCount);
                }
            }
        }
    };
    return AspectsPatterns;
}());
exports.AspectsPatterns = AspectsPatterns;
var AspectsPattern = (function () {
    function AspectsPattern(name, points, aspects) {
        this.name = name;
        this.points = points;
        this.aspects = aspects;
    }
    return AspectsPattern;
}());
